export { default } from "./AppTypography";

export type { AppTypographyProps } from "./AppTypography";
